// extracted by mini-css-extract-plugin
export default {"newsfeedoverviewContainer":"Newsfeedoverview_newsfeedoverviewContainer__LpCQd"};